export const getVersion = () => "v1.7.4";
